module.exports = __webpack_public_path__ + "static/media/stopnja_0_line@2x.61ac8ac9.png";